import { defineStore } from "pinia";

export const useFeaturesStore = defineStore("features", {
  state: () => ({
    featuresSetup: {}
  }),

  actions: {
    addFeatures(features) {
      const featuresSetup = {};
      features.forEach(feature => (featuresSetup[feature.key] = feature.enabled));
      this.featuresSetup = featuresSetup;
    }
  },

  getters: {
    isFeatureEnabled(state) {
      return featureName => {
        return !!state.featuresSetup[featureName];
      };
    }
  }
});
